import { useActiveOrgProfile } from '@/hooks/useActiveOrgProfile'
import { hasAdminPrivileges } from '@/services/utils'
import { DashboardHomeAdmin } from './Admin/Dashboard'
import { DashboardHomeUser } from './User/Dashboard'
import { LoadingMessage } from '@/components/loading-message'

export const DashboardHome = () => {
  const { data, isLoading } = useActiveOrgProfile()
  const isAdmin = hasAdminPrivileges(data?.user_role?.role_name)

  if (isLoading) {
    return <LoadingMessage message="Loading dashboard..." centered />
  }

  return isAdmin ? <DashboardHomeAdmin /> : <DashboardHomeUser />
}
